package com.shadowings.gero.presentation.component.quiz

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.testTag
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.FeaturePollOption
import com.shadowings.gero.domain.model.UserData
import com.shadowings.gero.presentation.component.FeaturePollForm
import com.shadowings.gero.presentation.ui.AppTheme
import com.shadowings.gero.presentation.util.DevicePreviews
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.feature_poll_btn_skip
import gero.composeapp.generated.resources.feature_poll_subtitle
import gero.composeapp.generated.resources.feature_poll_title
import org.jetbrains.compose.resources.stringResource

@DevicePreviews
@Preview
@Preview(name = "Dark", uiMode = 0x20, showBackground = true)
@Composable
private fun FeaturePollPagePreview() {
    AppTheme {
        Surface {
            FeaturePollPageComposable(
                userData = UserData(),
                onSubmit = { _, _ -> },
                onDismiss = {}
            )
        }
    }
}

// Rendered as a page inside the quiz's own HorizontalPager (see QuizScreen.kt), only inserted
// as a fallback when none of StreakCelebrationPageComposable/ReviewPromptPageComposable/
// CalendarPromptPageComposable qualify for this quiz completion — see StreakCelebrationPage.kt's
// comment for why this is a page and not a global dialog.
@Composable
fun FeaturePollPageComposable(
    userData: UserData,
    onSubmit: (option: FeaturePollOption, freeText: String) -> Unit,
    onDismiss: () -> Unit
) {
    var selectedOption by remember { mutableStateOf<FeaturePollOption?>(null) }
    var freeText by remember { mutableStateOf("") }

    Box(modifier = Modifier.fillMaxSize()) {
        Column(
            modifier = Modifier
                .padding(24.dp)
                .fillMaxSize()
                .verticalScroll(rememberScrollState()),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.SpaceBetween
        ) {
            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                Text(
                    text = stringResource(Res.string.feature_poll_title),
                    style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Bold),
                    textAlign = TextAlign.Center,
                    modifier = Modifier
                        .fillMaxWidth()
                        .semantics { testTag = "feature_poll_dialog_title" }
                )

                AlynFeedbackBox(
                    face = Faces.Doubt,
                    text = stringResource(Res.string.feature_poll_subtitle),
                    userData = userData
                )

                Spacer(Modifier.height(8.dp))

                FeaturePollForm(
                    selectedOption = selectedOption,
                    onOptionSelected = { selectedOption = it },
                    freeText = freeText,
                    onFreeTextChange = { freeText = it },
                    onSubmit = {
                        selectedOption?.let { onSubmit(it, freeText) }
                    }
                )
            }

            TextButton(
                onClick = onDismiss,
                modifier = Modifier.semantics { testTag = "feature_poll_btn_skip" }
            ) {
                Text(
                    text = stringResource(Res.string.feature_poll_btn_skip),
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant
                )
            }
        }
    }
}
